import React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/system';
import { darkenOrLighten, GREY, PLACEHOLDER_DARK, PLACEHOLDER_LIGHT, PRIMARY_COLOR, SECONDARY_COLOR } from '../../utils/color-const';

export const RequiredSkillsListWrapped = styled('div')({
  marginTop: '8px',
  justifyContent: 'center',
});

export const Box = styled('div')({
  height: '110px',
  width: '110px',
  textAlign: 'center',
  fontSize: '16px',
  wordWrap: 'break-word',
  border: '1px solid #85939d',
  margin: '5px 10px',
  borderRadius: '8px',
  '&:hover': {
    background: 'rgba(133, 147, 157, 0.15)',
    opacity: 0.8,
    cursor: 'pointer',
  },
});

export const IconBoxRowWrapper = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
});

export const BoxIconWrapper = styled('div')(({ secondary }) => ({
  '> svg': {
    fontSize: '50px !important',
    fill: secondary ? SECONDARY_COLOR : PRIMARY_COLOR,
    height: '80px',
  },
}));

export const ThirdWidth = styled('div')(({ theme }) => ({
  width: '33%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const FullWidth = styled('div')({
  width: '100%',
});

export const HalfWidth = styled('div')(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const SpecialLink = styled(Link)(({ color }) => ({
  textDecoration: 'none',
  color: color,
  '&:hover': {
    color: darkenOrLighten(color),
  },
}));

export const AbsoluteCenter = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const AbsoluteCenterFullWidth = styled('div')({
  textAlign: 'center',
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const Placeholder = styled('div')({
  '@keyframes placeholderBackground': {
    '0%': {
      backgroundPosition: '-800px 0',
    },
    '100%': {
      backgroundPosition: '800px 0',
    },
  },
  animationDuration: '1s',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: 'placeholderBackground',
  animationTimingFunction: 'linear',
  backgroundColor: PLACEHOLDER_LIGHT,
  backgroundImage: `linear-gradient(to right, ${PLACEHOLDER_LIGHT}, ${PLACEHOLDER_DARK} 10%, ${PLACEHOLDER_LIGHT} 25%)`,
  backgroundSize: '800px 1px',
  backgroundRepeat: 'repeat-y',
});